import { Drawer } from '@toggle/design-system';
import { Entity } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { WithFooterWrapper } from '~/components/with-footer-wrapper/WithFooterWrapper';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { CompanyToGeoWidget } from '~/widgets/company-to-geo-widget/CompanyToGeoWidget';

import * as S from './GeographicExposureDrawer.styles';
import { useGeographicDrawer } from './useGeographicDrawer';

export const DRAWER_GEOGRAPHIC_EXPOSURE = 'geographicExposure';

export interface GeographicExposureDrawerProps {
  entity: Entity;
}

export const GeographicExposureDrawer = ({
  entity,
}: GeographicExposureDrawerProps) => {
  const { closeDrawer, isDrawerOpen, type, countryCode, regionName } =
    useGeographicDrawer();
  const { t } = useTranslation(['countries']);

  const getHeaderLabel = () => {
    if (type === 'country' && countryCode) {
      return t(`countries:${countryCode.toUpperCase()}`);
    }

    if (type === 'region' && regionName) {
      return regionName;
    }

    return '';
  };

  const headerLabel = getHeaderLabel();

  if (!type) {
    return null;
  }

  return (
    <Drawer
      data-testid="geographic-exposure-drawer"
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      headerButton={<S.HeaderTitle>{headerLabel}</S.HeaderTitle>}
    >
      <WithFooterWrapper
        isWrappedComponentOpened={isDrawerOpen}
        trackingMetadata={{
          source: POSTHOG_TRACKING_SOURCES.GEOGRAPHIC_EXPOSURE_DRAWER,
        }}
      >
        <CompanyToGeoWidget entity={entity} />
      </WithFooterWrapper>
    </Drawer>
  );
};
